//@flow
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {Box, Typography, Container} from '@material-ui/core';
import {useHistory} from 'react-router-dom';
import HomeIcon from '@material-ui/icons/Home';
import CustomButton from '../../../elements/CustomButton/CustomButton';
import {colors} from '../../../assets/styles/colors';
import SearchWindowIcon from '../../../elements/icons/SearchWindowIcon';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    // background: `linear-gradient(135deg, ${colors.primary}15 0%, ${colors.secondary}10 100%)`,
    padding: '1.5rem .5rem ',
    flexGrow: 1,
    [theme.breakpoints.up('sm')]: {
      padding: '.75rem',
    },
  },
  container: {
    textAlign: 'center',
    maxWidth: 600,
  },
  iconContainer: {
    marginBottom: '1rem',
  },
  icon: {
    fontSize: '6rem',
    color: colors.primary,
    opacity: 0.8,
  },
  title: {
    fontSize: '4rem',
    fontWeight: 700,
    color: colors.grey900,
    marginBottom: '.75rem',
    background: `linear-gradient(45deg, ${colors.primary}, ${colors.primary} 50%, ${colors.secondary})`,
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',

    [theme.breakpoints.up('sm')]: {
      fontSize: '6rem',
    },

    [theme.breakpoints.up('md')]: {
      fontSize: '8rem',
    },
  },
  subtitle: {
    fontSize: '1.25rem',
    fontWeight: 500,
    color: colors.grey700,
    marginBottom: '.75rem',
  },
  description: {
    fontSize: '.875rem',
    color: colors.grey600,
    marginBottom: '.75rem',
    lineHeight: 1.6,
  },
  homeButton: {
    padding: '.75rem 1.5rem',
    fontSize: '.875rem',
    fontWeight: 600,
    marginBlock: '1rem',
    textTransform: 'none',
    boxShadow: `0 4px 12px ${colors.primary}30`,
    '&:hover': {
      boxShadow: `0 6px 16px ${colors.primary}40`,
      transform: 'translateY(-2px)',
    },
    transition: 'all 0.3s ease',
  },
  decorativeBox: {
    position: 'absolute',
    width: 200,
    height: 200,
    borderRadius: '50%',
    background: `linear-gradient(45deg, ${colors.primary}10, ${colors.secondary}10)`,
    zIndex: -1,
    top: '20%',
    right: '10%',
    opacity: 0.5,
  },
  decorativeBox2: {
    position: 'absolute',
    width: 150,
    height: 150,
    borderRadius: '50%',
    background: `linear-gradient(45deg, ${colors.secondary}10, ${colors.primary}10)`,
    zIndex: -1,
    bottom: '20%',
    left: '10%',
    opacity: 0.3,
  },
}));

export default function NotFoundPage() {
  const classes = useStyles();
  const history = useHistory();

  const handleGoHome = () => {
    history.push('/');
  };

  return (
    <div className={classes.root}>
      <div className={classes.decorativeBox} />
      <div className={classes.decorativeBox2} />

      <Container className={classes.container}>
        <Box className={classes.iconContainer}>
          <SearchWindowIcon className={classes.icon} />
        </Box>

        <Typography variant="h1" className={classes.title}>
          404
        </Typography>

        <Typography variant="h4" className={classes.subtitle}>
          Página no encontrada
        </Typography>

        <Typography className={classes.description}>
          Lo sentimos, la página que estás buscando no existe o ha sido movida.
          Verifica la URL o regresa al inicio para continuar navegando.
        </Typography>

        <CustomButton
          variant="contained"
          color="primary"
          className={classes.homeButton}
          startIcon={<HomeIcon />}
          onClick={handleGoHome}
        >
          Volver al inicio
        </CustomButton>
      </Container>
    </div>
  );
}
